import { Transaction } from "@mysten/sui/transactions";
import { bluefinPoolMap, cetusPoolMap, coinsList, collectAndSwapRewardsSingleLoop, getConf, getReceipts, getSuiClient, loopingPoolCoinMap, poolInfo, } from "../index.js";
import { AlphalendClient } from "@alphafi/alphalend-sdk";
import { getCoinObject } from "./bluefin.js";
export async function alphalendLoopingDeposit(poolName, amount, options) {
    let txb = new Transaction();
    if (poolName === "ALPHALEND-LOOP-SUI-STSUI") {
        txb = await alphalendSuiStsuiLoopDepositTx(amount, options);
    }
    return txb;
}
export async function alphalendLoopingWithdraw(poolName, xTokens, options) {
    let txb = new Transaction();
    if (poolName === "ALPHALEND-LOOP-SUI-STSUI") {
        txb = await alphalendSuiStsuiLoopWithdrawTx(xTokens, options);
    }
    return txb;
}
export const alphalendClient = new AlphalendClient("mainnet", getSuiClient());
export async function alphalendSuiStsuiLoopDepositTx(amount, options) {
    const C = getConf();
    const address = options.address;
    const txb = new Transaction();
    const poolName = "ALPHALEND-LOOP-SUI-STSUI";
    const poolData = poolInfo[poolName];
    await alphalendClient.updatePrices(txb, [
        coinsList["STSUI"].type,
        "0x2::sui::SUI",
    ]);
    const receipt = await getReceipts(poolName, address, true);
    let someReceipt;
    if (receipt.length == 0) {
        [someReceipt] = txb.moveCall({
            target: `0x1::option::none`,
            typeArguments: [poolData.receiptType],
            arguments: [],
        });
    }
    else {
        [someReceipt] = txb.moveCall({
            target: `0x1::option::some`,
            typeArguments: [receipt[0].content.type],
            arguments: [txb.object(receipt[0].objectId)],
        });
    }
    const [depositCoin] = txb.splitCoins(txb.gas, [amount]);
    txb.moveCall({
        target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_one_swap`,
        typeArguments: [coinsList["ALPHA"].type],
        arguments: [
            txb.object(C.ALPHA_5_VERSION),
            txb.object(poolData.investorId),
            txb.object(C.LENDING_PROTOCOL_ID),
            txb.object(bluefinPoolMap[`ALPHA-STSUI`]),
            txb.object(C.BLUEFIN_GLOBAL_CONFIG),
            txb.object(C.CLOCK_PACKAGE_ID),
        ],
    });
    txb.moveCall({
        target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_no_swap_v2`,
        arguments: [
            txb.object(C.ALPHA_5_VERSION),
            txb.object(poolData.investorId),
            txb.object(C.LENDING_PROTOCOL_ID),
            txb.object(C.CLOCK_PACKAGE_ID),
        ],
    });
    txb.moveCall({
        target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_two_swaps_v2`,
        typeArguments: [coinsList["BLUE"].type],
        arguments: [
            txb.object(C.ALPHA_5_VERSION),
            txb.object(poolData.investorId),
            txb.object(C.LENDING_PROTOCOL_ID),
            txb.object(C.LST_INFO),
            txb.object(C.SUI_SYSTEM_STATE),
            txb.object(cetusPoolMap[`BLUE-SUI`]),
            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
            txb.object(C.CLOCK_PACKAGE_ID),
        ],
    });
    txb.moveCall({
        target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::user_deposit_v3`,
        arguments: [
            txb.object(C.ALPHA_5_VERSION),
            txb.object(C.VERSION),
            someReceipt,
            txb.object(poolData.poolId),
            depositCoin,
            txb.object(poolData.investorId),
            txb.object(C.ALPHA_DISTRIBUTOR),
            txb.object(C.LENDING_PROTOCOL_ID),
            txb.object(C.LST_INFO),
            txb.object(C.SUI_SYSTEM_STATE),
            txb.object(C.CLOCK_PACKAGE_ID),
        ],
    });
    return txb;
}
export async function alphalendSingleLoopDeposit(poolName, amount, options) {
    const C = getConf();
    const address = options.address;
    const txb = new Transaction();
    const poolData = poolInfo[poolName];
    const coinName = loopingPoolCoinMap[poolName].supplyCoin;
    await alphalendClient.updatePrices(txb, [coinsList[coinName].type]);
    const receipt = await getReceipts(poolName, address, true);
    let someReceipt;
    if (receipt.length == 0) {
        [someReceipt] = txb.moveCall({
            target: `0x1::option::none`,
            typeArguments: [poolData.receiptType],
            arguments: [],
        });
    }
    else {
        [someReceipt] = txb.moveCall({
            target: `0x1::option::some`,
            typeArguments: [receipt[0].content.type],
            arguments: [txb.object(receipt[0].objectId)],
        });
    }
    let totalCoin;
    if (coinName === "SUI") {
        totalCoin = txb.gas;
    }
    else {
        totalCoin = await getCoinObject(coinsList[coinName].type, address, txb);
    }
    const [depositCoin] = txb.splitCoins(totalCoin, [amount]);
    await collectAndSwapRewardsSingleLoop(poolName, txb);
    txb.moveCall({
        target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::user_deposit`,
        typeArguments: [coinsList[coinName].type],
        arguments: [
            txb.object(C.ALPHA_ALPHALEND_VERSION),
            txb.object(C.VERSION),
            someReceipt,
            txb.object(poolData.poolId),
            depositCoin,
            txb.object(poolData.investorId),
            txb.object(C.ALPHA_DISTRIBUTOR),
            txb.object(C.LENDING_PROTOCOL_ID),
            txb.object(C.CLOCK_PACKAGE_ID),
        ],
    });
    txb.transferObjects([totalCoin], address);
    return txb;
}
export async function alphalendSuiStsuiLoopWithdrawTx(xTokens, options) {
    const C = getConf();
    const address = options.address;
    const txb = new Transaction();
    const poolName = "ALPHALEND-LOOP-SUI-STSUI";
    const poolData = poolInfo[poolName];
    const receipt = await getReceipts(poolName, address, true);
    const alphaReceipt = await getReceipts("ALPHA", address, true);
    await alphalendClient.updatePrices(txb, [
        coinsList["STSUI"].type,
        "0x2::sui::SUI",
    ]);
    if (receipt.length > 0) {
        let alpha_receipt;
        if (alphaReceipt.length == 0) {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::none`,
                typeArguments: [C.ALPHA_POOL_RECEIPT],
                arguments: [],
            });
        }
        else {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::some`,
                typeArguments: [alphaReceipt[0].content.type],
                arguments: [txb.object(alphaReceipt[0].objectId)],
            });
        }
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_one_swap`,
            typeArguments: [coinsList["ALPHA"].type],
            arguments: [
                txb.object(C.ALPHA_5_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(bluefinPoolMap[`ALPHA-STSUI`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_no_swap_v2`,
            arguments: [
                txb.object(C.ALPHA_5_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_two_swaps_v2`,
            typeArguments: [coinsList["BLUE"].type],
            arguments: [
                txb.object(C.ALPHA_5_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(C.LST_INFO),
                txb.object(C.SUI_SYSTEM_STATE),
                txb.object(cetusPoolMap[`BLUE-SUI`]),
                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        const [stsui_coin] = txb.moveCall({
            target: `${poolData.packageId}::alphafi_navi_sui_stsui_pool::user_withdraw_v3`,
            arguments: [
                txb.object(C.ALPHA_5_VERSION),
                txb.object(C.VERSION),
                txb.object(receipt[0].objectId),
                alpha_receipt,
                txb.object(C.ALPHA_POOL),
                txb.object(poolData.poolId),
                txb.pure.u64(xTokens),
                txb.object(poolData.investorId),
                txb.object(C.ALPHA_DISTRIBUTOR),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(C.LST_INFO),
                txb.object(C.SUI_SYSTEM_STATE),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `0x2::transfer::public_transfer`,
            typeArguments: [`0x2::coin::Coin<${coinsList["SUI"].type}>`],
            arguments: [stsui_coin, txb.pure.address(address)],
        });
    }
    else {
        throw new Error(`No ALPHALEND-LOOP-SUI-STSUI Receipt`);
    }
    return txb;
}
export async function alphalendSingleLoopWithdraw(poolName, xTokens, options) {
    const C = getConf();
    const address = options.address;
    const txb = new Transaction();
    const poolData = poolInfo[poolName];
    const receipt = await getReceipts(poolName, address, true);
    const alphaReceipt = await getReceipts("ALPHA", address, true);
    const coinName = loopingPoolCoinMap[poolName].supplyCoin;
    await alphalendClient.updatePrices(txb, [coinsList[coinName].type]);
    if (receipt.length > 0) {
        let alpha_receipt;
        if (alphaReceipt.length == 0) {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::none`,
                typeArguments: [C.ALPHA_POOL_RECEIPT],
                arguments: [],
            });
        }
        else {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::some`,
                typeArguments: [alphaReceipt[0].content.type],
                arguments: [txb.object(alphaReceipt[0].objectId)],
            });
        }
        await collectAndSwapRewardsSingleLoop(poolName, txb);
        const [coin] = txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::user_withdraw`,
            typeArguments: [coinsList[coinName].type],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(C.VERSION),
                txb.object(receipt[0].objectId),
                alpha_receipt,
                txb.object(C.ALPHA_POOL),
                txb.object(poolData.poolId),
                txb.pure.u64(xTokens),
                txb.object(poolData.investorId),
                txb.object(C.ALPHA_DISTRIBUTOR),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.transferObjects([coin], address);
    }
    else {
        throw new Error(`No ALPHALEND-LOOP-SUI-STSUI Receipt`);
    }
    return txb;
}
//# sourceMappingURL=alphalend.js.map